<template>
  <div class="img-main-container align-middle d-flex">
    <div
      class="d-table-cell align-middle"
      style="
        margin-top: auto;
        margin-bottom: auto;
        margin-left: auto;
        margin-right: auto;
      "
    >
      <img class="img-fluid" src="@/assets/img/LogoPapirusHDI.png" width="70%" />
    </div>
  </div>
</template>

<script>
export default {
  props: {}
};
</script>

<style scoped>
.img-main-container {
  width: 100%;
  height: 100%;
  background: url(../assets/img/loginbg.jpg) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.content {
  background-color: #000;
}
</style>
